'use client'

import type { Blog } from '@/payload-types'

import { useLivePreview } from '@payloadcms/live-preview-react'

import { BlogPageContent } from './BlogPageContent'
import { getClientSideURL } from '@/utilities/getURL'

type Props = {
  initialBlog: Blog
}

export const BlogPreview = ({ initialBlog }: Props) => {
  const { data } = useLivePreview<Blog>({
    depth: 2,
    initialData: initialBlog,
    serverURL: getClientSideURL(),
  })

  if (!data) return null

  return <BlogPageContent blog={data} />
}
